import { isInElement } from 'sierra-client/views/v3-author/command'
import { Editor } from 'slate'

export const isEnabled = ({ editor }: { editor: Editor }): boolean =>
  !isInElement(editor, ['block-quote', 'takeaway-item', 'flip-cards-card-container'])
